"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var stream_1 = require("stream");
var setImmediate = function (fn) {
    setTimeout(fn, 0);
};
var DevNull = /** @class */ (function (_super) {
    __extends(DevNull, _super);
    function DevNull() {
        return _super.call(this) || this;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    DevNull.prototype._write = function (_chunk, _encoding, callback) {
        return setImmediate(callback);
    };
    return DevNull;
}(stream_1.Writable));
exports.default = { null: new DevNull() };
//# sourceMappingURL=stream.js.map